import { api } from "./index"
import { IChatInfo, IChatMessage } from "../../types/chat"

export const chatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createChat: builder.mutation<IChatInfo, { type: "orders" | "users"; id: string; project_id?: string }>({
      query: ({ type, id, project_id }) => ({
        url: `public/chat-messages/create/dialog/${type}/${id}`,
        method: "POST",
        headers: { "Project-Id": project_id || undefined },
      }),
    }),
    getChatInfo: builder.query<IChatInfo, string>({
      query: (chatID) => ({
        url: `public/chat-messages/chats/${chatID}`,
        method: "GET",
      }),
    }),
    getUserChat: builder.query<IChatInfo, string>({
      query: (userID) => ({
        url: `public/chat-messages/find-user-chat`,
        method: "POST",
        body: { user_id: userID },
      }),
    }),
    // type = public | private - чаты, в которых есть публичные(for_client: true) или приватные сообщения
    getChatList: builder.query<
      { aDialogs: IChatInfo[]; bIsEnd: boolean; iCount: number },
      { limit?: number; offset?: number; search?: string; type?: "public" | "private" } | void
    >({
      query: (data) => {
        let queryString = "?type=public"

        if (data) {
          for (const key in data) {
            if (!queryString) queryString = "?"
            if (queryString && queryString !== "?") queryString = queryString + "&"
            // @ts-ignore
            queryString = queryString + `${key}=${data[key]}`
          }
        }

        return {
          url: `public/chat-messages/chats${queryString}`,
          method: "GET",
        }
      },
    }),
    getChatMessages: builder.query<
      { aMessages: IChatMessage[]; bIsEnd: boolean; iCount: number },
      { id: string; project_id: string }
    >({
      query: ({ id, project_id }) => ({
        url: `public/chat-messages/${id}?type=public`,
        method: "GET",
        headers: { "Project-Id": project_id || undefined },
      }),
    }),
    /*для `public/chat-messages/create/${id}` параметр for_client по дефолту ставится true на бекенде*/
    sendChatMessage: builder.mutation<
      IChatMessage,
      {
        id: string
        project_id: string
        data: { id: string; text?: string; attachments?: string[]; photos?: string[]; reply_id?: string | null }
      }
    >({
      query: ({ id, project_id, data }) => ({
        url: `public/chat-messages/create/${id}`,
        method: "POST",
        body: data,
        headers: { "Project-Id": project_id },
      }),
    }),
    markReadMessage: builder.mutation<void, { ids: string[]; project_id: string }>({
      query: ({ ids, project_id }) => ({
        url: `public/chat-messages/mark-readed`,
        method: "POST",
        body: { ids: ids },
        headers: { "Project-Id": project_id },
      }),
    }),
    getUserContacts: builder.mutation<void, { id: string }>({
      query: (data) => ({
        url: `public/user/contact`,
        method: "POST",
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetChatListQuery,
  useLazyGetChatListQuery,
  useLazyGetUserChatQuery,
  useLazyGetChatMessagesQuery,
  useCreateChatMutation,
  useSendChatMessageMutation,
  useMarkReadMessageMutation,
  useGetUserContactsMutation,
} = chatApi
